import classNames from "classnames";
import { useState } from "react";
import ExpansionPanel from "../../../../../components/ui/ExpansionPanel";
import useI18n from "../../../../../hooks/useTranslations";
import styles from "../../LockCalculator.module.css";
import { noticeText } from "./noticeText";
import { useNotices } from "./NoticesContext";

const SEVERITY_ITEM_CLASS = {
  error: styles.noticeItemError,
  warning: styles.noticeItemWarning,
  info: styles.noticeItemInfo,
} as const;

/** Every notice in one place, most severe first. Same expansion panel as the 3D preview; hidden while there are none. */
export const NoticesPanel = () => {
  const { notices, goToNotice } = useNotices();
  const { translation: t } = useI18n();
  const text = t.lockCalculatorModule.notices;
  const [open, setOpen] = useState(true);
  if (notices.length === 0) return null;

  return (
    <ExpansionPanel
      title={text.title}
      meta={text.count(notices.length)}
      expanded={open}
      onToggle={() => setOpen((prev) => !prev)}
      className={styles.previewPanel}
    >
      <ul className={styles.noticesList}>
        {notices.map((notice) => (
          <li key={notice.id} className={classNames(styles.noticeItem, SEVERITY_ITEM_CLASS[notice.severity])}>
            <span className={styles.noticeSeverity}>{text.severity[notice.severity]}</span>
            <span className={styles.noticeText}>{noticeText(notice, t)}</span>
            {(notice.action || notice.fields.length > 0) && (
              <button type="button" className={styles.noticeGo} onClick={() => goToNotice(notice)}>
                {notice.action ? text.goToAction : text.goToField}
              </button>
            )}
          </li>
        ))}
      </ul>
    </ExpansionPanel>
  );
};
